import { render, staticRenderFns } from "./SkeletonPanels.vue?vue&type=template&id=3c3394f0&"
import script from "./SkeletonPanels.vue?vue&type=script&lang=js&"
export * from "./SkeletonPanels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports